'use client';
import Cart from '@/app/_components/ui/icons/Cart.svg';
import Plus from '@/app/_components/ui/icons/Plus.svg';
import React from 'react';
import LoadingIcon from '../share/LoadingIcon';
import { useEffect, useState } from 'react';
import Link from 'next/link';
import useCart from '@/app/_hooks/useCart';

export default function ProductListAddToCart({ cartItem }) {
  const { cart, addToCart } = useCart();
  const [isProductInCart, setIsProductInCart] = useState(false);
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const [iconColor, setIconColor] = useState('#2A75BB');

  useEffect(() => {
    if (cart && cart.items) {
      setIsProductInCart(
        cart.items.some((item) => item.price_id === cartItem?.price_id)
      );
    }
  }, [cart, cart?.items]);

  const handleHover = () => {
    setIconColor('#fff');
  };

  const handleUnhover = () => {
    setIconColor('#2A75BB');
  };

  const addToCartHandler = async () => {
    // dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    // dataLayer.push({
    //   event: 'add_to_cart',
    //   ecommerce: {
    //     currency: 'IRR',
    //     value: cartItem.variation.sale,
    //     items: [
    //       {
    //         item_id: cartItem.price_id,
    //         item_name: cartItem.variation.product.title,
    //         discount: cartItem.variation.regular - cartItem.variation.sale,
    //         item_list_id: `${pageType}${pageId}`,
    //         item_list_name: `${pageName}`,
    //         price: cartItem.variation.sale,
    //         quantity: 1,
    //       },
    //     ],
    //   },
    // });

    try {
      setIsAddingToCart(true); // Set loading state to true
      await addToCart({ items: [cartItem] });
    } finally {
      setIsAddingToCart(false); // Reset loading state after the addToCart action completes
    }
  };

  return (
    <div
      className="border  border-color-primary hover:bg-color-primary   rounded-md p-1.5 bg-primary-25 cursor-pointer"
      onMouseEnter={handleHover}
      onMouseLeave={handleUnhover}
    >
      {isProductInCart ? (
        <Link href="/checkout/cart" target="_blank">
          <Cart stroke={iconColor} />
        </Link>
      ) : (
        <div className="relative z-20 " onClick={addToCartHandler}>
          {isAddingToCart ? <LoadingIcon /> : <Plus stroke={iconColor} />}
        </div>
      )}
    </div>
  );
}
